const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);
  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function registerPushSubscription() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
    console.warn('Push notifications not supported');
    return null;
  }

  if (!VAPID_PUBLIC_KEY) {
    console.warn('VAPID public key not configured');
    return null;
  }

  try {
    var registration = await navigator.serviceWorker.register('/sw-push.js');
    await navigator.serviceWorker.ready;

    var permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('Notification permission denied');
      return null;
    }

    var subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
    });

    var API_URL = process.env.REACT_APP_BACKEND_URL;
    var response = await fetch(API_URL + '/api/push/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({
        subscription: subscription.toJSON(),
        device_info: navigator.userAgent.substring(0, 200)
      })
    });

    if (response.ok) {
      return subscription;
    }
    return null;
  } catch (err) {
    console.error('Push registration failed:', err);
    return null;
  }
}

export async function unregisterPushSubscription() {
  try {
    var registration = await navigator.serviceWorker.getRegistration('/sw-push.js');
    if (!registration) return;

    var subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await subscription.unsubscribe();

      var API_URL = process.env.REACT_APP_BACKEND_URL;
      await fetch(API_URL + '/api/push/unsubscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ endpoint: subscription.endpoint })
      });
    }
  } catch (err) {
    console.error('Push unregister failed:', err);
  }
}

export async function isPushSubscribed() {
  try {
    var registration = await navigator.serviceWorker.getRegistration('/sw-push.js');
    if (!registration) return false;
    var subscription = await registration.pushManager.getSubscription();
    return !!subscription;
  } catch (err) {
    return false;
  }
}

export function isPushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && !!VAPID_PUBLIC_KEY;
}
